import roadmapSprite from '@/assets/sprite/roadmap-sprite.svg';
import { SVGProps } from 'react';

const baseDicePath = `${roadmapSprite}#sicbo__dice__`;

type SicBoDiceIconsProps = {
    dices: number;
};
type SicBoIconsProps = SicBoDiceIconsProps & SVGProps<SVGSVGElement>;

export const DiceIcon = ({ dices, ...otherProps }: SicBoIconsProps) => {
    return (
        <svg
            overflow="visible"
            viewBox="0 0 40 40"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            {...otherProps}
        >
            <use href={`${baseDicePath}die-${dices}`} />
        </svg>
    );
};
